// style.ts
import styled from 'styled-components';
import { themeOptions } from 'styles';

interface StyledBasicSearchProps {
  $noinput?: string;
}

export const StyledBasicSearch = styled.div<StyledBasicSearchProps>`
  position: relative;
  width: 342px;

  .MuiInputBase-root {
    padding-right: 8px;
  }

  .MuiTextField-root {
    margin: 0;
    width: 100%;
    background-color: ${({ $noinput }) =>
      $noinput === '$noinput' ? '#80808017' : `${themeOptions.palette.white.main}`};
    border: 1px solid #dadada;
    border-radius: 6px;

    &:hover {
      box-shadow: 0 0 0 3px var(--color-off-white);
    }
    &:active {
      border-color: ${themeOptions.palette.green.main};
    }

    input {
      padding: 10px 0 10px 12px;
      font-size: 14px;
      font-weight: 400;
      color: ${themeOptions.palette.grey.dark};
      line-height: 18px;
    }
  }

  .MuiOutlinedInput-input {
    width: 100%;
    border-radius: 6px;
    outline: none;
    appearance: none;
    background-color: ${themeOptions.palette.white.main};
  }

  button {
    margin: 0 4px;
  }
`;
